import storiesTypes from '../consts/loyalty/storiesTypes';
import {MODAL_TYPES} from '../consts/modal/modalTypes';
import routes from '../consts/routes';
import themeStyle from '../consts/themeStyle';

const overrideThemeConfig = {
    pages: [
        {route: routes.CLUB, theme: themeStyle.DARK},
        {route: routes.CLUB_BADGE, theme: themeStyle.DARK},
        {route: routes.CLUB_SWITCH, theme: themeStyle.DARK},
    ],
    modals: [
        {modalType: MODAL_TYPES.CLUB_PAGE_STORIES, theme: themeStyle.DARK},
        {modalType: MODAL_TYPES.CLUB_PAGE_QUIZ_MODAL, theme: themeStyle.DARK},
        {modalType: MODAL_TYPES.CLUB_PAGE_REPORT_MODAL, theme: themeStyle.DARK},
        {modalType: MODAL_TYPES.CLUB_PAGE_PUZZLE_MODAL, theme: themeStyle.DARK},
        {modalType: MODAL_TYPES.CLUB_PAGE_ARTICLE_MODAL, theme: themeStyle.DARK},
        {modalType: MODAL_TYPES.CLUB_PAGE_PROMPT_REWARDS, theme: themeStyle.DARK},
        {modalType: MODAL_TYPES.CLUB_PAGE_FEEDBACK_MODAL, theme: themeStyle.DARK},
        {modalType: MODAL_TYPES.CLUB_PAGE_REWARD_LIST_MODAL, theme: themeStyle.DARK},
        {modalType: MODAL_TYPES.CLUB_PAGE_REWARD_CARD_MODAL, theme: themeStyle.DARK},
        {modalType: MODAL_TYPES.TIPS_AND_TUTORIALS_MEDIA_MODAL, theme: themeStyle.DARK},
    ],
    stories: [{storiesType: storiesTypes.LEVIA, theme: themeStyle.LIGHT}],
};

export default overrideThemeConfig;
